import { Outlet } from 'react-router';
// MUI
import useMediaQuery from '@mui/material/useMediaQuery';
// CUSTOM COMPONENTS
import MobileSidebar from './components/MobileSidebar';
import DashboardSidebar from './components/DashboardSidebar';
import DashboardHeader from './components/DashboardHeader';
import FullWidthBodyWrapper from './components/FullWidthBodyWrapper';
import LayoutSetting from '@/layouts/layout-parts/LayoutSetting';
// DASHBOARD LAYOUT BASED CONTEXT PROVIDER
import LayoutProvider from './context/layoutContext';

/**
 * Full-width dashboard layout variant
 * Use this for pages that need the full screen width (like the graphic editor)
 */
export default function FullWidthDashboardLayout() {
  const downLg = useMediaQuery(theme => theme.breakpoints.down('lg'));
  return (
    <LayoutProvider>
      {/* CONDITIONALLY RENDER THE SIDEBAR */}
      {downLg ? <MobileSidebar /> : <DashboardSidebar />}

      <FullWidthBodyWrapper>
        {/* DASHBOARD HEADER SECTION */}
        <DashboardHeader />

        {/* MAIN CONTENT RENDER SECTION */}
        <Outlet />

        {/* LAYOUT SETTING SECTION */}
        <LayoutSetting />
      </FullWidthBodyWrapper>
    </LayoutProvider>
  );
}
